import * as React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  FormLabel,
  Divider,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { VENDOR_REGISTRATION_STEP_2 } from "../../utils/Validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleKeyPress } from "../../common/Events";
import saveUserDetailsService from "../../services/saveUserDetailsService";
import requestOTPService from "../../services/requestOtpService";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";

const SecondStep = ({
  onClickNext,
  handleBack,
  setFormData,
  formData,
  resendCount,
}) => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  const formOption = {
    resolver: yupResolver(VENDOR_REGISTRATION_STEP_2),
    defaultValues: { ...formData },
  };
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOption);
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const requestBody = {
        ...formData,
        ...data,
      };

      const saveUserDetailsResponse = await saveUserDetailsService(
        baseUrl,
        requestBody
      );
      if (saveUserDetailsResponse.messageCode === 6) {
        const applicationId = saveUserDetailsResponse?.applicationId;
        const newRequestBody = {
          ...requestBody,
          applicationId: applicationId,
        };

        setFormData(newRequestBody);
        onClickNext();
        if (resendCount < 3) {
          await requestOTPService(baseUrl, newRequestBody);
          showNotification("Info", "OTP Sent to Register Email Id", "success");
        }
      } else {
        showNotification(
          "Error",
          saveUserDetailsResponse?.message ?? "Unable To Save User Details "
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Save User Details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            <Box>
              <form>
                <Grid
                  container
                  spacing={1}
                  justifyContent="left"
                  alignItems="center"
                >
                  <Grid item xs={12} sm={12}>
                    <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      Vendor Name
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="vendorName"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      {...register("vendorName", { required: true })}
                      error={Boolean(errors?.vendorName)}
                      helperText={
                        errors?.vendorName ? "This field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      Vendor SPOC Email
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="vendorSPOCemail"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      {...register("vendorSPOCemail")}
                      error={Boolean(errors?.vendorSPOCemail)}
                      helperText={errors?.vendorSPOCemail?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      Vendor SPOC Mobile Number
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="vendorSPOCMobile"
                      fullWidth
                      required
                      size="small"
                      type="number"
                      onKeyDown={handleKeyPress}
                      autoComplete="off"
                      {...register("vendorSPOCMobile", { required: true })}
                      error={Boolean(errors?.vendorSPOCMobile)}
                      helperText={errors?.vendorSPOCMobile?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormLabel
                      required={true}
                      sx={{ width: "220px" }}
                      className="stepperFormLabel"
                    >
                      SPOC First Name
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="SPOCFirstName"
                      fullWidth
                      size="small"
                      required
                      autoComplete="off"
                      {...register("SPOCFirstName", { required: true })}
                      error={Boolean(errors?.SPOCFirstName)}
                      helperText={
                        errors?.SPOCFirstName?.message
                          ? errors?.SPOCFirstName?.message
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormLabel
                      required={true}
                      sx={{ width: "220px" }}
                      className="stepperFormLabel"
                    >
                      SPOC Last Name
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="SPOCLastName"
                      fullWidth
                      size="small"
                      required
                      autoComplete="off"
                      {...register("SPOCLastName", { required: true })}
                      error={Boolean(errors?.SPOCLastName)}
                      helperText={
                        errors?.SPOCLastName?.message
                          ? errors?.SPOCLastName?.message
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
          <Divider />
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button variant="outlined" onClick={handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
              >
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
    </>
  );
};

export default SecondStep;
